module.exports = __webpack_public_path__ + "img/V87.262f5882.jpg";